<template>
  <div>
    <v-container class="py-0">
      <template v-for="(category, c) in categories">
        <template v-if="category.visible">
          <div :key="'category-' + c" class="my-12">
            <v-row>
              <v-col :id="encodeURI(category.url)" class="text-center">
                <router-link
                  :to="'/materials/' + category.url"
                  v-html="category.name"
                  class="material-category-title not-text-decoration"
                  @click.native="$vuetify.goTo('#' + encodeURI(category.url))"
                ></router-link>
              </v-col>
            </v-row>

            <template v-if="category.description != ''">
              <v-row justify="center" class="mb-6 mb-md-12">
                <v-col cols="12" md="9">
                  <div class="material-category-subtitle not-text-decoration text-center" v-html="category.description"></div>
                </v-col>
              </v-row>
            </template>

            <v-row justify="center">
              <v-col cols="12" md="9">
                <v-row>
                  <template v-for="(material, m) in materials">
                    <template v-if="category._id == material.category._id">
                      <v-col
                        cols="6"
                        md="3"
                        :key="'material-' + c + '-' + m"
                        class="text-center pointer"
                        @click="dialog = true; carousel_materials = m;"
                      >
                        <v-avatar class="d-lg-none" size="137">
                          <v-img
                            :src="
                              'https://artlesscms.actstudio.xyz/' +
                              material.cover.path
                            "
                          ></v-img>
                        </v-avatar>

                        <v-avatar
                          class="d-none d-lg-inline-flex d-xl-none"
                          size="200"
                        >
                          <v-img
                            :src="
                              'https://artlesscms.actstudio.xyz/' +
                              material.cover.path
                            "
                          ></v-img>
                        </v-avatar>

                        <v-avatar class="d-none d-xl-inline-flex" size="230">
                          <v-img
                            :src="
                              'https://artlesscms.actstudio.xyz/' +
                              material.cover.path
                            "
                          ></v-img>
                        </v-avatar>
                        <span class="d-block mt-4">{{ material.name }}</span>
                      </v-col>
                    </template>
                  </template>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </template>
      </template>
    </v-container>

    <v-dialog v-model="dialog" :content-class="'materials-modal mx-0'">
      <v-carousel height="100vh" :hide-delimiters="true" v-model="carousel_materials">
        <template v-for="(material, m) in materials">
          <template v-if="material.category.visible">
            <v-carousel-item :key="'item-carousel-'+m">
              <v-row style="height: 100%;" align="center">
                <v-col class="text-center">
                  <div style="position: relative;" class="d-inline-block text-right">
                    <div class="pointer" @click="dialog = false;">
                      <v-icon color="white" size="40">mdi-close</v-icon>
                    </div>
                    <img :src="'https://www.artlesscms.actstudio.xyz/'+material.cover.path" class="mx-auto d-block" style="max-height: calc(100vh - 200px); max-width: 500px;">

                  </div>
                </v-col>
              </v-row>
            </v-carousel-item>
          </template>
        </template>

        <div class="v-carousel__controls" style="left: auto; right: auto; background-color: rgba(0,0,0,.4)">
          <span class="white--text gtAmerica uppercase bold" style="font-size: 30px">{{materials[carousel_materials].name}}</span>
        </div>
      </v-carousel>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      materials: [],
      categories: [],
      dialog: false,
      carousel_materials: 0
    };
  },
  beforeMount: function () {
    var aux = this;
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Materials?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // filter: {
          //     url: this.$route.params.url,
          // },
          populate: 1, // resolve linked collection items
          sort: { _o: 1 },
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.materials = res.entries));

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/MaterialCategories?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // filter: {
          //     url: this.$route.params.url,
          // },
          // populate: 1, // resolve linked collection items
          sort: { _o: 1 },
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.categories = res.entries))
      .then(() => this.scrollToCategory());
  },
  methods: {
    scrollToCategory: function () {
      if (this.$route.params != undefined) {
        var aux = this;
        setTimeout(() => {
          aux.$vuetify.goTo("#" + this.$route.params.material);
        }, 2000);
      }
    },
    scrollTo: function (element) {
      this.$vuetify.goTo("#" + element);
    },
  },
  mounted: function () {
    var breadcrumbs = [
      {
        text: "Home",
        link: "/",
        isLink: true,
      },
      {
        text: "Materials",
        link: "/materials",
        isLink: false,
      },
    ];
    this.$emit("updateStatus", breadcrumbs);
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Materials',
      'page_path': '/materials'
    });
  },
  watch: {},
};
</script>